export default __webpack_public_path__ + "static/media/garden.1f4cb4e1.svg";